<template>
  <a-spin :spinning="formOption.busy">
    <a-form :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 12 }"
    >

      <a-form-item label="关键词">
        <a-input v-decorator="['keyWordsName', rules.keyWordsName]" :maxLength="10"/>
      </a-form-item>

    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>

  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import XEUtils from "xe-utils";
import {formatter as fmt} from "@/utils/form-formatter";
//菜单api
import {dataApi} from "@/services/question/keyWords";

console.info(XEUtils)


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    name: {
      keyWordsName: [{required: true, message: "请输入关键词"}],
    },
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad() {

}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  console.log(vm)
  console.log(entities)
  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  watch: {},
  components: {},
  data() {
    return {
      type: 0,
      bussTypeArr: [],
      treeData: []
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
  },
};
</script>

<style scoped lang="stylus">

</style>